import React, { useEffect, useState, useCallback } from "react";
import useSize from "../../../../Utils/useSize/useSize";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Filter from "./Filter";
import Loading from "../../../../Utils/Loading/Loading";
import NotFound from "../../../../Utils/NotFound/NotFound";
import Menu from "./Menu";
import SymbolQtyCard from "./SymbolQtyCard";

const backend = await new Backend().init();

export default function SymbolQty({ close }) {
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);
  const [symbols, setSymbols] = useState([]);
  const [allSymbols, setAllSymbols] = useState([]);

  const [counts, setCounts] = useState({
    nse: 0,
    mcx: 0,
    mcx_options: 0,
    options: 0,
    nse_cash: 0,
    comex: 0,
    crypto: 0,
    forex: 0,
    us_stock: 0,
    sgx: 0,
    index: 0,
    dgcx: 0,
    ncdex: 0,
  });

  const loadSymbolQtyList = useCallback(async () => {
    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id: localStorage.getItem("id"),
      };

      const res = await backend.symbol_qty_list(data);
      if (res.error === "False") {
        setSymbols(res.symbol || []);
        setAllSymbols(res.symbol || []);
        setCounts({
          nse: res.nse,
          mcx: res.mcx,
          mcx_options: res.mcx_options,
          options: res.options,
          nse_cash: res.nse_cash,
          comex: res.comex,
          crypto: res.crypto,
          forex: res.forex,
          us_stock: res.us_stock,
          sgx: res.sgx,
          index: res.index,
          dgcx: res.dgcx,
          ncdex: res.ncdex,
        });
      } else {
        toast.error(res.message || "Failed to load symbol data");
      }
    } catch (error) {
      toast.error("Something went wrong while loading data");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSymbolQtyList();
  }, [loadSymbolQtyList]);

  const filterSymbol = (typeIndex) => {
    const map = [
      "nse",
      "mcx",
      "mcx_options",
      "options",
      "nse_cash",
      "comex",
      "crypto",
      "forex",
      "us_stock",
      "sgx",
      "index",
      "dgcx",
      "ncdex",
    ];

    if (typeIndex >= 0 && map[typeIndex]) {
      setSymbols(allSymbols.filter((x) => x.type === map[typeIndex]));
    } else {
      setSymbols(allSymbols);
    }
  };

  const searchSymbol = (query) => {
    const q = query.toLowerCase();

    if (q.length > 1) {
      setSymbols(
        allSymbols.filter((x) =>
          (x.symbol_display || "").toLowerCase().includes(q)
        )
      );
    } else {
      setSymbols(allSymbols);
    }
  };

  return (
    <div className="flex flex-col">
      <Filter
        filter={filterSymbol}
        search={searchSymbol}
        {...counts}
        close={close}
      />
      <Menu />

      <div
        style={{
          height: windowSize[1] - 180,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          padding: "10px",
        }}
      >
        {loading ? (
          <div className="flex items-center justify-center">
            <Loading height={windowSize[1] - 180} />
          </div>
        ) : symbols.length > 0 ? (
          symbols.map((item) => (
            <SymbolQtyCard
              key={item.id}
              item={item}
              reload={loadSymbolQtyList}
            />
          ))
        ) : (
          <NotFound
            height={windowSize[1] - 180}
            title="No Symbols Found"
            subtext="Try adjusting filters or search criteria."
            small
          />
        )}
      </div>
    </div>
  );
}
